import { render } from "./Layout.vue?vue&type=template&id=20c55f4a&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=20c55f4a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20c55f4a"

export default script